export default "__VITE_ASSET__DzYCSTlq__"